export { default, getStaticProps } from "app/club/page";
